import cx from "clsx"
import styles from "./container.module.less"

export default function Container({ children, contain = true, className = "", style = {}, customWidth, ...rest }) {
  return (
    <div
      className={cx(contain && styles.container, "w-100", className)}
      style={{
        ...style,
        "--container-width": customWidth,
      }}
      {...rest}
    >
      {children}
    </div>
  )
}
